/**
 * The app-level Skillz "shell" pseudo-game (`skillzapp/common/constants.ts:37`).
 *
 * The partner multicade has no game context of its own, so every game-scoped wallet
 * / store / user call transacts against this id. It has no Unity build; its
 * fingerprint is the fixed server-held token applied by the /apigw relay
 * (resolveFingerprintToken). Lives in its own module (not a route file) so the
 * partner layout, page and store route can all import it without a page exporting a
 * non-route symbol.
 */
export const SKILLZ_APP_GAME_ID = 19369;
